import UserAuthentication from './plugins/userAuthentication';
import FormDataFactory from './plugins/formDataFactory';
import ExportExcel from './plugins/globalExportToExcel';
import DashboardPlugin from './plugins/dashboard-plugin';
import Capacitor from './plugins/capacitor';
import Vue from 'vue';
import App from './App.vue';
import VueAxios from 'vue-axios'
import router from '@/routers/router/'
import './config/msg'
import AxiosInstance from './backend/axios'
import VueMask from 'v-mask'
import Vuelidate from 'vuelidate'
import moment from 'moment'
import store from './store'
import ECharts from 'vue-echarts'
import { use } from 'echarts/core'
// import VeeValidate from 'vee-validate';

// Importing Layouts
import Default from "@/layouts/Default";
import DashboardPprLayout from "@/layouts/DashboardPprLayout";
import DashboardCriLayout from "@/layouts/DashboardCriLayout";
import DashboardLayout from '@/layouts/DashboardLayout';
import AuthenticationLayout from "./layouts/Authentication";
import VueListPicker from 'vue-list-picker'
import 'leaflet/dist/leaflet.css';

// Compostion api
import VueCompositionApi from '@vue/composition-api'

// import ECharts modules manually to reduce bundle size
import {
  CanvasRenderer
} from 'echarts/renderers'
import {
  BarChart
} from 'echarts/charts'
import {
  GridComponent,
  TooltipComponent
} from 'echarts/components'

use([
  CanvasRenderer,
  BarChart,
  GridComponent,
  TooltipComponent
]);

import { Icon } from 'leaflet';
import "./filters";

import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective);

// register globally (or you can do it locally)
Vue.component('v-chart', ECharts)

// register directive v-money and component <money>

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

Vue.component('ppr-layout', DashboardPprLayout)
Vue.component('cri-layout', DashboardCriLayout)
Vue.component('default-layout', Default)
Vue.component('dashboard-layout', DashboardLayout)
Vue.component('authentication-layout', AuthenticationLayout)

Vue.use(VueCompositionApi);

Vue.use(VueListPicker)
// form validate
Vue.use(Vuelidate)
// Vue.use(VeeValidate);
// input mask
Vue.use(VueMask);

// router setup
Vue.use(DashboardPlugin);

// Capacitor setup
Vue.use(Capacitor);

// User auth setup
Vue.use(UserAuthentication);

// Form data factory
Vue.use(FormDataFactory);

//Export to excel
Vue.use(ExportExcel);

Vue.config.productionTip = false

Vue.use(VueAxios, {
  secured: AxiosInstance,
  plain:   AxiosInstance,
  $http:   AxiosInstance,
})

moment.locale('pt-BR');
Vue.filter('formatDate', function(value, option = null) {
  if (value) {
    if(option == 'full')  return moment(String(value)).format('LLLL')
    if(option == 'short') return moment(String(value)).format('L')
    if(option == 'time')  return moment(String(value)).format('LT')
    if(option == 'datetime')  return moment(String(value)).format('LLL')
    return moment(String(value)).format('DD/MM/YYYY')
  }
})

new Vue({
  router,
  AxiosInstance,
  render: h => h(App),

  data() {
    return {
      currentUser: {
        name: '',
        email: '',
        token: '',
        cpf: '',
        all_permissions: [],
        role: {},
      },
    }
  },

  mounted() {
    // this.$authenticateUser()
  },

  store,

  watch: {
    currentUser (newCurrentUser) {
      if (!newCurrentUser) return;

      var newUser = newCurrentUser
      newUser.token = newUser.token || JSON.parse(localStorage.currentUser).token
    }
  }
}).$mount("#app")
